import { AdminOrganizationPermission, AdminOrganizationPermissions } from "../types/adminEntities";
import { TranslationKey } from "../../shared/i18n/i18n";

export type DisabledActionReason =
  | "permission"
  | "data-problem"
  | "subscription-limit"
  | null;

export const hasOrganizationPermission = (
  organizationPermissions: AdminOrganizationPermissions | null | undefined,
  permission: AdminOrganizationPermission,
) => organizationPermissions?.permissions.includes(permission) ?? false;

export const formatDisabledActionTooltip = (
  label: string,
  reason: DisabledActionReason,
  t: (key: TranslationKey) => string,
) => (
  reason === "permission"
    ? `${label} ${t("admin.permission.disabledTooltipSuffix")}`
    : reason === "subscription-limit"
      ? `${label} ${t("admin.subscription.limitReachedTooltipSuffix")}`
      : reason === "data-problem"
        ? `${label} ${t("admin.dataProblem.disabledTooltipSuffix")}`
      : label
);
